import React from 'react'
import { useLocalstorageState } from 'rooks'

const tooltipSequence: OnboardingTip[] = [
  'bet-loop-share-bet-button',
  'bet-loop-view-user-profile',
  'bet-loop-follow-user',
  'bet-loop-view-my-profile',
]

export const useOnboardingTooltips = (tipId: OnboardingTip) => {
  const [seenTooltips, setSeenTooltips] = useLocalstorageState<OnboardingTip[]>(
    'tooltip:bet-loop-onboarding-tooltips',
    []
  )
  const [currentTooltipId, setCurrentTooltipId] = React.useState<OnboardingTip | null>(null)

  React.useEffect(() => {
    if (seenTooltips.includes(tipId)) {
      setCurrentTooltipId(null)
      return
    }

    /* nextTip: the first tip in tooltipSequence that is not in seenTooltips
     * currentTooltipId: used across components to determine if that tooltip should be shown */
    const nextTip = tooltipSequence.find(id => !seenTooltips.includes(id))
    setCurrentTooltipId(nextTip ?? null)
  }, [seenTooltips, tipId])

  const onDismissed = React.useCallback(
    (id: OnboardingTip) => {
      setSeenTooltips(prev => {
        if (prev.includes(id)) return prev
        return [...prev, id]
      })
    },
    [setSeenTooltips]
  )

  return { currentTooltipId, onDismissed }
}

// =====
// Types
// =====

type OnboardingTip =
  | 'bet-loop-share-bet-button'
  | 'bet-loop-view-user-profile'
  | 'bet-loop-follow-user'
  | 'bet-loop-view-my-profile'
